import script from "./CategoryEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryEdit.vue?vue&type=script&setup=true&lang=js"

import "./CategoryEdit.vue?vue&type=style&index=0&id=7a305766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a305766"]])

export default __exports__